/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ue_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If a percent-escape is malformed (like a lone %), decoding shows an error instead of producing garbage.`)
};

const es_ue_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si un escape de porcentaje tiene un formato incorrecto (como un % solitario), la decodificación muestra un error en lugar de producir basura.`)
};

const de_ue_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn ein Prozentzeichen-Escape fehlerhaft ist (wie ein einzelnes %), zeigt Dekodieren einen Fehler statt Müll zu produzieren.`)
};

const nl_ue_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als een percent-ontsnapping misvormde is (zoals een alleenstaande %), toont decodering een fout in plaats van rommel te produceren.`)
};

const fr_ue_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si un caractère d'échappement en pourcentage est mal formé (comme un % isolé), le décodage affiche une erreur au lieu de produire du charabia.`)
};

const it_ue_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se uno escape percentuale è malformato (come una % solitaria), la decodifica mostra un errore invece di produrre spazzatura.`)
};

const pt_br2_ue_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se um escape de porcentagem for malformado (como um % isolado), a decodificação mostra um erro em vez de produzir lixo.`)
};

const pt_ue_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se um escape de percentagem for malformado (como um % isolado), a descodificação apresenta um erro em vez de produzir dados sem sentido.`)
};

const ja_ue_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーセント エスケープが形成が悪い場合 (孤立した % など)、デコーディングはガベージを生成する代わりにエラーを表示します。`)
};

const zh_ue_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果百分号转义格式有误（比如单独出现的 %），解码会显示错误提示，而不是产生乱码。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ue_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ue_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ue_faq3_a", locale)
	if (locale === "en") return en_ue_faq3_a(inputs)
	if (locale === "es") return es_ue_faq3_a(inputs)
	if (locale === "de") return de_ue_faq3_a(inputs)
	if (locale === "nl") return nl_ue_faq3_a(inputs)
	if (locale === "fr") return fr_ue_faq3_a(inputs)
	if (locale === "it") return it_ue_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_ue_faq3_a(inputs)
	if (locale === "pt") return pt_ue_faq3_a(inputs)
	if (locale === "ja") return ja_ue_faq3_a(inputs)
	return zh_ue_faq3_a(inputs)
};